import { parse } from 'node-html-parser';

export const parseHtmlString = (htmlContent: string) =>
  parse(htmlContent).textContent;
